import React, { useEffect, useState } from 'react';
import './HeaderLogo.scss';
import { LocalSettings } from '../../../Clients/RestaurantSite/types';
import {getLocalConfigurationByLocalId} from '../../../../crud/management_api/local_configurations';

interface HeaderLogoProps {
  isCollapsed?: boolean;
}

const HeaderLogo: React.FC<HeaderLogoProps> = ({ isCollapsed = false }) => {
  // Load the initial colorMode from localStorage (defaulting to light)
  const initialColorMode = localStorage.getItem('colorMode') || 'light';
  const [mode, setMode] = useState(initialColorMode);
  const [ulrLocalLogo , setUrlLocalLogo] = useState<string | null>(null);

  useEffect(() => {
    // Fetch the local configuration to get the logo URL
    const fetchLocalLogo = async () => {
      try {
        const userContext = localStorage.getItem('user');
        const localId = userContext ? JSON.parse(userContext).local_id : 0;
        const response = await getLocalConfigurationByLocalId(localId);
        const localConfig: LocalSettings = response.data;
        setUrlLocalLogo(localConfig.image_url);
      } catch (error) {
        console.error('Error fetching local configuration:', error);
      }
    };

    fetchLocalLogo();
  }, []);

  useEffect(() => {
    // Create a MutationObserver to listen for changes in the data-color-mode attribute
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-color-mode') {
          const newMode = document.documentElement.getAttribute('data-color-mode') || 'light';
          setMode(newMode);
        }
      }
    });

    observer.observe(document.documentElement, { attributes: true });

    // Cleanup the observer when the component unmounts
    return () => observer.disconnect();
  }, []);

  return (  
    <div className="panel-header-logo">
      <a href="/App">
        <div className="logo">
          {isCollapsed ? (
            // Logo circular cuando está colapsado
            <div className="logo-collapsed">
              <img 
                alt="logo"
                className="logo-img-collapsed"
                src={`${process.env.PUBLIC_URL}/logos/Recurso 49MEDIOPUNTO.png`}
              />
            </div>
          ) : (
            // Logo completo cuando está expandido
            <div className="logo-img-wrapper">
              <span className="logo-icon">
                <img 
                  alt="logo"
                  className="logo-img"
                  src={`${process.env.PUBLIC_URL}/mp_logo_0${mode === 'dark' ? '1' : '2'}.png`} 
                />
              </span>
            </div>
          )}
        </div>
      </a>
    </div>
  );
};

export default HeaderLogo;
